(function () {
  const U = window.UIX;
  const Core = window.RB.Core;
  const APP = window.APP;

  const el = U.el;
  const esc = U.esc;
  const menuCfg = U.menuCfg;
  const saveMenuCfg = U.saveMenuCfg;

  function deckLegend(deck) { return deck && deck.legend ? RB.Setup.findCard(deck.legend) : null; }
  function deckChampion(deck) { return deck && deck.champion ? RB.Setup.findCard(deck.champion) : null; }

  function deckDomains(deck) {
    const legend = deckLegend(deck);
    if (legend && legend.domains && legend.domains.length) return legend.domains;
    const seen = {};
    const out = [];
    for (const id of deck.deck || []) {
      const c = RB.Setup.findCard(id);
      for (const d of (c && c.domains) || []) {
        if (!seen[d]) { seen[d] = 1; out.push(d); }
      }
    }
    return out.slice(0, 2);
  }

  function blockingErrs(deck) {
    if (!deck) return ["deck missing"];
    const errs = RB.Decklists.validate(deck);
    return deck.id.indexOf("demo-") === 0 ? [] : errs;
  }

  function deckStats(deck) {
    let runes = 0;
    for (const d in deck.runes || {}) runes += deck.runes[d];
    return {
      main: (deck.deck || []).length,
      side: (deck.side || []).length,
      runes: runes,
      field: (deck.battlefields || []).length,
      errs: RB.Decklists.validate(deck),
    };
  }

  const artImg = U.artImg;

  function tally(label, n, cap) {
    const t = el("span", "mstally");
    t.appendChild(el("span", "mslbl", esc(label)));
    t.appendChild(el("b", n === cap ? null : "bad", esc(String(n)) + "<i>/" + cap + "</i>"));
    return t;
  }

  function counter(label, n, cap) {
    const c = el("div", "mscnt" + (n === cap ? "" : " warn"));
    c.appendChild(el("span", "mslbl", esc(label)));
    c.appendChild(el("span", "mscntn msnum" + (n === cap ? "" : " bad"), esc(String(n)) + "<i>/" + cap + "</i>"));
    return c;
  }

  function ribbon(title, right, cls) {
    const r = el("div", "msrib" + (cls ? " " + cls : ""));
    r.appendChild(el("span", "msribt", esc(title)));
    if (right !== undefined) r.appendChild(el("span", "msribn mslbl", esc(right)));
    return r;
  }

  const DOMAIN_ORDER = Core.DOMAINS;
  const RUNE_TOTAL = U.RUNE_TOTAL;
  const FIELD_TOTAL = U.FIELD_TOTAL;

  function deckLegendName(deck) {
    const c = deckLegend(deck);
    return c ? c.name : "No legend";
  }

  function deckFields(deck) {
    return (deck.battlefields || []).slice();
  }

  function legendPool() {
    if (legendPool.cache) return legendPool.cache;
    const byName = {};
    const out = [];
    for (const c of window.CARD_DB) {
      if ((c.types || []).indexOf("legend") < 0) continue;
      if (c.token || byName[c.name]) continue;
      byName[c.name] = c;
      out.push({ name: c.name, card: c, domains: c.domains || [] });
    }
    out.sort(function (a, b) { return a.name.localeCompare(b.name); });
    legendPool.cache = out;
    return out;
  }

  function legendGroups(decks) {
    const byName = {};
    for (const deck of decks) {
      const name = deckLegendName(deck);
      if (!byName[name]) byName[name] = { name: name, card: deckLegend(deck), decks: [] };
      if (!byName[name].card) byName[name].card = deckLegend(deck);
      byName[name].decks.push(deck);
    }
    const favs = RB.Decklists.favorites();
    const out = [];
    for (const name in byName) {
      const g = byName[name];
      g.decks.sort(function (a, b) {
        const fa = favs.indexOf(a.id) >= 0, fb = favs.indexOf(b.id) >= 0;
        if (fa !== fb) return fa ? -1 : 1;
        return a.name.localeCompare(b.name);
      });
      g.favorite = g.decks.some(function (d) { return favs.indexOf(d.id) >= 0; });
      g.domains = (g.card && g.card.domains) || deckDomains(g.decks[0]);
      g.legal = g.decks.filter(function (d) { return !RB.Decklists.validate(d).length; }).length;
      out.push(g);
    }
    out.sort(function (a, b) {
      if (b.decks.length !== a.decks.length) return b.decks.length - a.decks.length;
      return a.name.localeCompare(b.name);
    });
    return out;
  }

  function deckUi() {
    if (!APP.deckui) APP.deckui = { search: "", runes: {}, showAll: true, legend: null, page: 0 };
    return APP.deckui;
  }

  const STAR_ON = U.STAR_ON;

  function starButton(deck) {
    return U.starButton(deck, "msstarbtn", "Favourite — click to unstar", "Mark as favourite");
  }

  function cardTile(card, cls, sizes) {
    const tile = el("div", "msct" + (cls ? " " + cls : ""));
    if (card) {
      tile.title = card.name;
      tile.appendChild(artImg(card, "", { sizes: sizes || "80px" }));
    } else {
      tile.className += " msslot";
    }
    return tile;
  }

  const runeCard = U.runeCard;

  function runeLine(doms, cls) {
    const line = el("div", "msruneline" + (cls ? " " + cls : ""));
    for (const dom of doms) line.appendChild(cardTile(runeCard(dom), "msrunec", "40px"));
    return line;
  }

  function runeSpread(deck) {
    const line = el("div", "msruneline msvarrunes");
    for (const dom of U.slots(U.runeList(deck), RUNE_TOTAL)) line.appendChild(cardTile(dom ? runeCard(dom) : null, "msrunec", "40px"));
    return line;
  }

  function fieldRow(deck, cls) {
    const row = el("div", "msvarbfs" + (cls ? " " + cls : ""));
    for (const id of U.slots(deckFields(deck), FIELD_TOTAL, FIELD_TOTAL)) row.appendChild(cardTile(id ? RB.Setup.findCard(id) : null, "land"));
    return row;
  }

  function legendTile(group, selected, onpick) {
    const built = group.decks.length > 0;
    const tile = el("div", "mschamp" + (selected ? " on" : "") + (built ? "" : " empty"));
    tile.dataset.find = group.name.toLowerCase();
    tile.onclick = onpick;
    if (group.card) tile.appendChild(artImg(group.card, "mschampart", { sizes: "180px" }));
    tile.appendChild(el("div", "mschampfade"));

    const top = el("div", "mschamptop");
    top.appendChild(runeLine(group.domains, "mschampruns"));
    if (group.favorite) top.appendChild(el("span", "mschampfav", STAR_ON));
    if (built) top.appendChild(el("span", "mschampn msnum", esc(String(group.decks.length))));
    tile.appendChild(top);

    const text = el("div", "mschamptext");
    text.appendChild(el("span", "mschampname", esc(group.name)));
    if (built) {
      const sub = group.decks.length + (group.decks.length === 1 ? " build" : " builds") +
        (group.legal < group.decks.length ? " · " + (group.decks.length - group.legal) + " incomplete" : "");
      text.appendChild(el("span", "mschampsub", esc(sub)));
    } else {
      text.appendChild(el("span", "mschampsub msfirst",
        "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2.4' stroke-linecap='round'><path d='M12 5v14M5 12h14'></path></svg><span>First build</span>"));
    }
    tile.appendChild(text);
    return tile;
  }

  function newBuildFor(group) {
    const base = group.decks[0];
    const deck = {
      id: "custom-" + Date.now(),
      name: group.name + " — new build",
      tagline: "",
      legend: group.card ? group.card.id : null,
      champion: base ? base.champion : null,
      battlefields: base ? deckFields(base) : [],
      runes: base ? JSON.parse(JSON.stringify(base.runes || {})) : {},
      deck: base && base.champion ? [base.champion] : [],
    };
    enterBuilder(builderPath("new"), deck);
  }

  function manageRow(deck, cfg) {
    const row = el("div", "msmanage");
    const edit = el("button", "btn ghost small", deck.builtin ? "Edit copy" : "Edit");
    edit.onclick = function (e) { e.stopPropagation(); U.editDeck(deck); };
    row.appendChild(edit);
    const dup = el("button", "btn ghost small", "Duplicate");
    dup.onclick = function (e) {
      e.stopPropagation();
      const copy = JSON.parse(JSON.stringify(deck));
      delete copy.builtin;
      copy.id = "custom-" + Date.now();
      copy.name = deck.name + " (copy)";
      RB.Decklists.saveCustom(copy);
      cfg.seats[0].deck = copy.id;
      saveMenuCfg(cfg);
      U.render();
    };
    row.appendChild(dup);
    const del = el("button", "btn danger small", "Delete");
    del.disabled = !!deck.builtin;
    if (deck.builtin) del.title = "Preconstructed decks cannot be deleted — duplicate it first.";
    del.onclick = function (e) {
      e.stopPropagation();
      if (deck.builtin) return;
      if (!confirm("Delete build \"" + deck.name + "\"?")) return;
      RB.Decklists.deleteCustom(deck.id);
      cfg.seats[0].deck = "pg-annie";
      if (cfg.seats[1].deck === deck.id) cfg.seats[1].deck = "pg-yi";
      saveMenuCfg(cfg);
      U.render();
    };
    row.appendChild(del);
    return row;
  }

  function buildCard(deck, selected, cfg, onpick) {
    const st = deckStats(deck);
    const champ = deckChampion(deck);
    const card = el("div", "msvar" + (selected ? " on" : ""));
    card.onclick = onpick;

    const top = el("div", "msvartop");
    top.appendChild(starButton(deck));
    top.appendChild(el("span", "msvarname", esc(deck.name)));
    const flag = el("span", "msflag " + (st.errs.length ? "bad" : "ok"), st.errs.length ? "Incomplete" : "Legal");
    flag.style.marginLeft = "auto";
    top.appendChild(flag);
    card.appendChild(top);

    const spread = el("div", "msvarspread");
    const champWrap = el("div", "msvarchamp");
    champWrap.appendChild(cardTile(champ, "msvarid", "120px"));
    champWrap.appendChild(el("span", "mslbl", esc(champ ? champ.name.split(",")[0] : "no champion")));
    spread.appendChild(champWrap);
    spread.appendChild(fieldRow(deck));
    card.appendChild(spread);

    card.appendChild(runeSpread(deck));

    const foot = el("div", "msvarfoot");
    foot.appendChild(tally("Main", st.main, 40));
    if (st.side) foot.appendChild(tally("Side", st.side, RB.Decklists.SIDE_MAX));
    foot.appendChild(tally("Rune", st.runes, RUNE_TOTAL));
    foot.appendChild(tally("Field", st.field, FIELD_TOTAL));
    if (deck.builtin) {
      const ev = deck.library && deck.event ? deck.event : null;
      const kind = el("span", "mslbl", ev
        ? esc((ev.placement > 0 ? "#" + ev.placement + " · " : "") + (ev.date || "") + (ev.players ? " · " + ev.players + " players" : ""))
        : "Preconstructed");
      if (ev && ev.name) kind.title = ev.name;
      kind.style.marginLeft = "auto";
      foot.appendChild(kind);
    }
    card.appendChild(foot);

    if (selected) {
      if (st.errs.length) card.appendChild(el("div", "deckerr msclamp", "⚠ " + esc(st.errs.join(" · "))));
      else if (deck.tagline || (deck.library && deck.event && deck.event.name)) {
        card.appendChild(el("div", "mstagline msclamp", esc(deck.tagline || deck.event.name)));
      }
      card.appendChild(manageRow(deck, cfg));
    }
    return card;
  }

  function legendRail(group, selected, cfg) {
    const rail = el("div", "mspane msbev msrail");
    const inner = el("div", "mspanein msbev msrailin");
    rail.appendChild(inner);

    if (!group) {
      inner.appendChild(el("div", "msempty", "No legend selected."));
      return rail;
    }

    const head = el("div", "mschead");
    head.appendChild(cardTile(group.card, "mscheadart", "180px"));
    const meta = el("div", "mscheadmeta");
    meta.appendChild(el("span", "mscheadname", esc(group.name.toUpperCase())));
    const doms = el("div", "mscheaddoms");
    doms.appendChild(runeLine(group.domains, "mscheadruns"));
    doms.appendChild(el("span", "mslbl", esc(group.domains.join(" / "))));
    meta.appendChild(doms);
    const stats = el("div", "mscheadstats");
    stats.appendChild(counter("Builds", group.decks.length, group.decks.length));
    stats.appendChild(counter("Legal", group.legal, group.decks.length));
    meta.appendChild(stats);
    head.appendChild(meta);
    inner.appendChild(head);

    inner.appendChild(ribbon("Builds", group.decks.length + (group.decks.length === 1 ? " variation" : " variations"), "bbrib"));

    const vars = el("div", "msvars");
    if (!group.decks.length) {
      vars.appendChild(el("div", "msempty", "No build uses this legend yet."));
    }
    for (const deck of group.decks) {
      (function (deck) {
        vars.appendChild(buildCard(deck, selected && deck.id === selected.id, cfg, function () {
          cfg.seats[0].deck = deck.id;
          saveMenuCfg(cfg);
          U.render();
        }));
      })(deck);
    }
    const add = el("button", "msvarnew",
      "<svg viewBox='0 0 24 24' width='14' height='14' fill='none' stroke='currentColor' stroke-width='2.4' stroke-linecap='round'><path d='M12 5v14M5 12h14'></path></svg><span>New " + esc(group.name) + " build</span>");
    add.onclick = function () { newBuildFor(group); };
    vars.appendChild(add);
    inner.appendChild(vars);

    return rail;
  }

  function denseTable(groups, selected, cfg) {
    const pane = el("div", "mspane msbev mslist");
    const inner = el("div", "mspanein msbev msdensein");
    pane.appendChild(inner);

    const table = el("table", "msdense");
    const thead = el("thead");
    const hrow = el("tr");
    for (const h of ["", "", "Build", "Champion", "Battlefields", "Rune spread", "Status", ""]) {
      hrow.appendChild(el("th", null, esc(h)));
    }
    thead.appendChild(hrow);
    table.appendChild(thead);

    const body = el("tbody");
    for (const g of groups) {
      if (!g.decks.length) continue;
      const grow = el("tr", "msgrp");
      const cell = el("td");
      cell.colSpan = 8;
      const name = el("div", "msgrpname");
      name.appendChild(cardTile(g.card, "msgrpart", "40px"));
      name.appendChild(runeLine(g.domains, "msgrpruns"));
      name.appendChild(el("b", null, esc(g.name.toUpperCase())));
      name.appendChild(el("span", "mslbl", esc(g.decks.length + (g.decks.length === 1 ? " build" : " builds"))));
      cell.appendChild(name);
      grow.appendChild(cell);
      body.appendChild(grow);

      for (const deck of g.decks) {
        (function (deck) {
          const st = deckStats(deck);
          const row = el("tr", "msrowd" + (selected && deck.id === selected.id ? " on" : ""));
          row.onclick = function () {
            cfg.seats[0].deck = deck.id;
            saveMenuCfg(cfg);
            U.render();
          };
          row.appendChild(el("td", "mspin"));
          const star = el("td", "msstar");
          star.appendChild(starButton(deck));
          row.appendChild(star);
          row.appendChild(el("td", "msbname", esc(deck.name)));

          const champ = deckChampion(deck);
          const cc = el("td");
          const cwrap = el("div", "mslgdcell");
          cwrap.appendChild(cardTile(champ, "msdthumb", "40px"));
          cwrap.appendChild(el("span", "msdim", esc(champ ? champ.name : "no champion")));
          cc.appendChild(cwrap);
          row.appendChild(cc);

          const bc = el("td");
          bc.appendChild(fieldRow(deck, "msdbfs"));
          row.appendChild(bc);

          const rc = el("td");
          const rline = el("div", "msruneline msdrunes");
          for (const dom of DOMAIN_ORDER) {
            const n = (deck.runes || {})[dom] || 0;
            if (!n) continue;
            const grp = el("span", "msrunegrp");
            grp.appendChild(cardTile(runeCard(dom), "msrunec", "40px"));
            grp.appendChild(el("b", "msnum", esc(String(n))));
            rline.appendChild(grp);
          }
          rc.appendChild(rline);
          row.appendChild(rc);

          const sc = el("td");
          const status = el("div", "msstatus");
          status.appendChild(el("span", "msdot " + (st.errs.length ? "bad" : "ok")));
          status.appendChild(el("span", "msdim", st.errs.length ? "Incomplete" : "Legal"));
          sc.appendChild(status);
          row.appendChild(sc);

          const ac = el("td", "msdacts");
          ac.appendChild(manageRow(deck, cfg));
          row.appendChild(ac);

          body.appendChild(row);
        })(deck);
      }
    }
    table.appendChild(body);

    const scroll = el("div", "msdscroll");
    scroll.appendChild(table);
    inner.appendChild(scroll);
    return pane;
  }

  function renderDeckManager() {
    const root = document.getElementById("app");
    root.innerHTML = "";
    root.className = "";
    const cfg = menuCfg();
    const ui = deckUi();
    const dense = cfg.deckView === "dense";
    const decks = RB.Decklists.all();
    const selected = RB.Decklists.get(cfg.seats[0].deck) || decks[0] || null;

    let groups = legendGroups(decks);
    const built = groups.length;
    if (ui.showAll) {
      const have = {};
      for (const g of groups) have[g.name] = 1;
      for (const p of legendPool()) {
        if (have[p.name]) continue;
        groups.push({ name: p.name, card: p.card, decks: [], domains: p.domains, legal: 0 });
      }
    }
    const picked = [];
    for (const dom in ui.runes) if (ui.runes[dom]) picked.push(dom);
    if (picked.length) {
      groups = groups.filter(function (g) {
        return picked.some(function (d) { return g.domains.indexOf(d) >= 0; });
      });
    }
    const query = (ui.search || "").trim().toLowerCase();
    if (query) {
      groups = groups.filter(function (g) { return g.name.toLowerCase().indexOf(query) >= 0; });
    }

    let group = null;
    for (const g of groups) if (ui.legend && g.name === ui.legend) group = g;
    if (!group && selected) {
      const name = deckLegendName(selected);
      for (const g of groups) if (g.name === name) group = g;
    }
    if (!group) group = groups[0] || null;

    let legal = 0;
    for (const d of decks) if (!RB.Decklists.validate(d).length) legal++;

    const mine = decks.filter(function (d) { return !d.builtin; }).length;
    const shell = U.screenShell("menuscreen", "DECKBUILDER", built + (built === 1 ? " legend · " : " legends · ") +
      decks.length + (decks.length === 1 ? " build" : " builds") +
      " · " + mine + " stored in this browser");
    const wrap = shell.wrap;
    const acts = shell.acts;
    const cnt = el("div", "mscnt");
    cnt.appendChild(el("span", "mslbl", "Legends"));
    cnt.appendChild(el("span", "mscntn msnum", esc(String(built)) + "<i>/" + legendPool().length + "</i>"));
    acts.appendChild(cnt);

    const views = el("div", "msviews");
    for (const v of [["roster", "Roster"], ["dense", "Dense"]]) {
      (function (v) {
        const b = el("button", "btn small" + ((cfg.deckView === "dense") === (v[0] === "dense") ? " on" : ""), v[1]);
        b.onclick = function () {
          cfg.deckView = v[0];
          saveMenuCfg(cfg);
          U.render();
        };
        views.appendChild(b);
      })(v);
    }
    acts.appendChild(views);

    const duel = el("button", "btn ghost", "Play");
    duel.title = "Play a game with these decks";
    duel.onclick = function () { location.href = "/play"; };
    acts.appendChild(duel);
    const imp = el("button", "btn ghost", "Import deck");
    imp.title = "Paste a text list or a deck code";
    imp.onclick = function () { U.importDeckDialog(); };
    acts.appendChild(imp);
    const col = el("button", "btn ghost", "Collection");
    col.title = "Download all your decks as one file, or import such a file";
    col.onclick = function () { U.collectionDialog(); };
    acts.appendChild(col);
    const nb = el("button", "btn primary", "New deck");
    nb.onclick = function () { U.newDeck(); };
    acts.appendChild(nb);

    if (APP.error) wrap.appendChild(el("div", "menuerr", "⚠ " + esc(APP.error)));

    const body = el("div", "msbody");
    let layout = null;

    if (dense) {
      body.appendChild(denseTable(groups, selected, cfg));
    } else {
      const list = el("div", "mspane msbev mslist");
      const listIn = el("div", "mspanein msbev mslistin");
      listIn.appendChild(ribbon("Legends", built + " built · " + legal + " of " + decks.length + " tournament legal", "bbrib"));

      const filters = el("div", "msfilters");
      const search = document.createElement("input");
      search.className = "msfind";
      search.type = "search";
      search.placeholder = "Search legend…";
      search.value = ui.search;
      search.oninput = function () {
        ui.search = search.value;
        ui.page = 0;
        U.render();
        const next = document.querySelector(".msfind");
        if (next) { next.focus(); next.setSelectionRange(next.value.length, next.value.length); }
      };
      filters.appendChild(search);

      const runeset = el("div", "msruneset");
      for (const dom of DOMAIN_ORDER) {
        (function (dom) {
          const t = cardTile(runeCard(dom), "msrunec" + (picked.length && !ui.runes[dom] ? " off" : ""), "40px");
          t.title = dom;
          t.onclick = function () {
            ui.runes[dom] = !ui.runes[dom];
            ui.page = 0;
            U.render();
          };
          runeset.appendChild(t);
        })(dom);
      }
      filters.appendChild(runeset);

      const seg = el("div", "msviews msfilterseg");
      const bBuilt = el("button", "btn small" + (ui.showAll ? "" : " on"), "Built only");
      bBuilt.onclick = function () { ui.showAll = false; ui.page = 0; U.render(); };
      seg.appendChild(bBuilt);
      const bAll = el("button", "btn small" + (ui.showAll ? " on" : ""), "All legends");
      bAll.onclick = function () { ui.showAll = true; ui.page = 0; U.render(); };
      seg.appendChild(bAll);
      filters.appendChild(seg);
      listIn.appendChild(filters);

      const roster = el("div", "msroster");
      listIn.appendChild(roster);
      const pager = el("div", "bbpager msrosterpager");
      listIn.appendChild(pager);
      list.appendChild(listIn);
      body.appendChild(list);
      body.appendChild(legendRail(group, selected, cfg));

      layout = function () {
        const fit = window.UIDOM.gridFit(roster, {
          min: 132, ratio: window.UIDOM.CARD_RATIO, gap: 10,
        });
        const pages = Math.max(1, Math.ceil(groups.length / fit.per));
        if (ui.page >= pages) ui.page = pages - 1;
        if (ui.page < 0) ui.page = 0;

        roster.innerHTML = "";
        const from = ui.page * fit.per;
        for (const g of groups.slice(from, from + fit.per)) {
          (function (g) {
            roster.appendChild(legendTile(g, group && g.name === group.name, function () {
              ui.legend = g.name;
              if (g.decks.length) cfg.seats[0].deck = g.decks[0].id;
              saveMenuCfg(cfg);
              U.render();
            }));
          })(g);
        }
        if (!groups.length) roster.appendChild(el("div", "msempty msspan", "No legend matches those filters."));

        pager.innerHTML = "";
        const step = function (label, to, on, off) {
          const p = el("span", "bbpg" + (on ? " on" : "") + (off ? " off" : ""), label);
          if (!off) p.onclick = function () { ui.page = to; layout(); };
          return p;
        };
        pager.appendChild(step("‹", ui.page - 1, false, ui.page === 0));
        const start = Math.max(0, Math.min(ui.page - 2, pages - 5));
        for (let i = start; i < Math.min(pages, start + 5); i++) {
          pager.appendChild(step(String(i + 1), i, i === ui.page, false));
        }
        pager.appendChild(step("›", ui.page + 1, false, ui.page >= pages - 1));
        pager.appendChild(el("span", "mslbl bbpginfo",
          esc(groups.length + " legends · " + fit.cols + "×" + fit.rows + " per page · " + pages + (pages === 1 ? " page" : " pages"))));
      };
    }

    wrap.appendChild(body);
    root.appendChild(wrap);
    if (layout) layout();
  }

  window.UIDOM.onResize(function () {
    if (APP.screen === "menu" && APP.mode === "manage") U.render();
  });

  function renderMenu() {
    if (APP.mode === "manage") renderDeckManager();
    else U.renderPlay();
  }

  const DECK_LIST_PATH = "/deckbuilder";

  function builderPath(id) { return DECK_LIST_PATH + "/" + encodeURIComponent(id); }

  function enterBuilder(path, base) {
    if (location.pathname === path) {
      history.replaceState({ view: "builder" }, "", path);
    } else {
      history.pushState({ view: "builder" }, "", path);
      APP.builderPushed = true;
    }
    U.openBuilder(base);
  }

  function editDeck(deck) {
    if (APP.mode !== "manage") { location.href = builderPath(deck.id); return; }
    enterBuilder(builderPath(deck.id), deck);
  }

  function newDeck() {
    if (APP.mode !== "manage") { location.href = builderPath("new"); return; }
    enterBuilder(builderPath("new"), null);
  }

  function showDeckList() {
    APP.builder = null;
    APP.builderPushed = false;
    APP.screen = "menu";
    U.render();
  }

  function backToDecks() {
    if (APP.builderPushed) { APP.builderPushed = false; history.back(); return; }
    history.replaceState({ view: "list" }, "", DECK_LIST_PATH);
    showDeckList();
  }

  function applyDeckRoute() {
    const m = location.pathname.match(/^\/deckbuilder\/(.+)$/);
    if (!m) { showDeckList(); return; }
    const id = decodeURIComponent(m[1]);
    if (id === "new") { U.openBuilder(null); return; }
    const deck = RB.Decklists.get(id);
    if (deck) { U.openBuilder(deck); return; }
    history.replaceState({ view: "list" }, "", DECK_LIST_PATH);
    APP.error = "That deck no longer exists.";
    showDeckList();
  }

  Object.assign(U, { blockingErrs: blockingErrs, deckLegend: deckLegend, deckChampion: deckChampion, deckDomains: deckDomains, deckStats: deckStats, runeLine: runeLine, runeSpread: runeSpread, fieldRow: fieldRow, cardTile: cardTile, counter: counter, editDeck: editDeck, newDeck: newDeck, backToDecks: backToDecks, applyDeckRoute: applyDeckRoute, DECK_LIST_PATH: DECK_LIST_PATH, renderMenu: renderMenu, ribbon: ribbon });
})();
